export default __webpack_public_path__ + "static/pitch-sans-web-medium-1bbd707ace19b355169b7303fe9a0494.woff2";